<itenary-planner [dealsDataFull]="dealsDataFull"></itenary-planner>